import { Section, Chapter, Reveal } from "./Section";
import LeadForm from "./LeadForm";

const EVENTS = [
  "Church Services", "Conferences", "Leadership Gatherings", "Revivals", "Workshops",
  "Spiritual Warfare Classes", "Men's Events", "Ministry Training", "Motivational Speaking", "Kingdom Business Events",
];

export default function Invite() {
  return (
    <Section id="invite" testid="invite-section" className="bg-white/[0.015]">
      <div className="grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-6">
          <Chapter number="08" label="Invite Prophet Terrell Turner" testid="invite-chapter"
            title={<>Prophetic Insight &amp; Practical Wisdom<br /><span className="text-vg">for Your Next Gathering</span></>}
            sub="Whether addressing a congregation, developing leaders, mentoring emerging voices, or teaching practical Kingdom principles — four decades of ministry experience come to every assignment." />
          <Reveal delay={0.2} className="mt-10">
            <p className="mb-5 font-mono text-sm font-semibold uppercase tracking-[0.25em] text-vg">Available for select</p>
            <div className="flex flex-wrap gap-2">
              {EVENTS.map((e) => (
                <span key={e} data-testid={`invite-event-${e.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="glass px-4 py-2.5 rounded-full text-slate-200 text-sm font-medium tracking-wide hover:border-amber-400/50 hover:text-white hover:-translate-y-0.5 transition-all duration-300 cursor-default">
                  {e}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-6 glow-frame">
          <div className="rounded-[1.7rem] bg-[#0B0E16] p-7 sm:p-9">
            <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-vg">Submit an Invitation</p>
            <LeadForm type="invite" idPrefix="invite" extra={["phone", "organization", "message"]} submitLabel="Submit an Invitation" />
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
